import api from 'repositories/api'

import { BulkGoalPayload } from './goalPayload'

const BULK_GOAL_REQUEST_TIMEOUT_MS = 120_000

interface SubmittedGoal {
  _id: string
  config?: { active?: boolean }
}

const ensureGoalWasActivated = (goal: SubmittedGoal) => {
  if (!goal?.config?.active) throw new Error('A meta foi criada, mas permaneceu em rascunho.')
  return goal
}

export const createStoreGoal = async (payload: BulkGoalPayload) => {
  const { data: finalGoal } = await api.axios.post<SubmittedGoal>('/goal/complete', payload, {
    timeout: BULK_GOAL_REQUEST_TIMEOUT_MS
  })
  return ensureGoalWasActivated(finalGoal)
}
